import z from 'zod'

import { counterStyles } from 'features/globalSetup/api/types/counterStyle'
import { MAX_SAFE_GQL_INTEGER } from 'providers/tanstack-query/constants'
import { validateJSONSchema } from 'utils/json'
import { RichPlacementMultiAnchor } from '../../hooks/useGetRichPlacementMultiAnchor'

export const schema = z.object({
  counterStyle: z.enum(counterStyles).default('progressBar'),
  customStyling: z.string().superRefine(validateJSONSchema),
  displayAfterUserInteraction: z.boolean().default(false),
  frequencyCappingEnabled: z.boolean().default(false).optional(),
  fullWidthMode: z.boolean().default(false),
  impressionLimit: z.number().min(1).max(100).default(1).optional(),
  showCloseButton: z.boolean().default(false),
  singleAdViewTime: z.number().min(2_000).max(MAX_SAFE_GQL_INTEGER).default(5_000),
  timeWindow: z.number().min(1).max(1_440).default(60).optional(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (multiAnchor: RichPlacementMultiAnchor): Schema => {
  const {
    counterStyle,
    customStyling,
    displayAfterUserInteraction,
    frequencyCappingEnabled,
    fullWidthMode,
    impressionLimit,
    showCloseButton,
    singleAdViewTime,
    timeWindow,
  } = multiAnchor

  return {
    counterStyle,
    customStyling,
    displayAfterUserInteraction,
    frequencyCappingEnabled,
    fullWidthMode,
    impressionLimit,
    showCloseButton,
    singleAdViewTime,
    timeWindow,
  }
}
